// NPM
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

// ANT COMPONENTS
import { StackScreen } from '@life-line-lab/components-react';

// INTERNAL COMPONENTS
import CustomerProfileIndividualFormComponent from 'Components/customer-management/customer-profile-individual-form';
import CustomerProfileCreateSelectionComponent from 'Components/customer-management/customer-profile-create-selection';
import CustomerProfileCompanyFormComponent from 'Components/customer-management/customer-profile-company-form';

// SERVICES
import { createCustomer } from 'Services/customer.service';

// HELPERS
import { toaster } from 'Helpers/toaster';
import { encode } from 'Helpers/enc';

// TYPES
import { CustomerCompanyFormInputType, CustomerFormInputType } from 'Types/customer-form.types';
import { getCompanyList } from 'Services/account.services';
import { OrgList } from 'Types/common.types';
import { useSession } from 'Hooks/index';

interface CustomerCreatePageProps {

}

const CustomerCreatePage: React.FC<CustomerCreatePageProps> = ({

}) => {

    const history = useHistory();
    const { t }= useTranslation();
    const { org } = useSession();

    const [orgList, setOrgList] = useState<OrgList[]>([]);

    useEffect(() => {
        if (location.pathname.indexOf("create/company") > -1 ||
        location.pathname.indexOf("/create/individual") > -1) {
            handleFetchCompanyList();
        }
        document.body.classList.add('stack-screen--open');
        return () => document.body.classList.remove('stack-screen--open');
    }, []);

    const handleCloseStackScreen = () => {
      history.push('/customer-management/profile');
    }

    const componentTypeToLoad = () => {
        if (location.pathname.indexOf("/create/individual") > -1) {
            return <CustomerProfileIndividualFormComponent 
                onSubmit={handleCreateCustomer}
                orgList={orgList}
            />;
        }
        if (location.pathname.indexOf("create/company") > -1) {
            return <CustomerProfileCompanyFormComponent 
                onSubmit={handleCreateCustomer}
                orgList={orgList}
            />;
        }
        return <CustomerProfileCreateSelectionComponent />;
    }

    const handleCreateCustomer = async (data: CustomerFormInputType | CustomerCompanyFormInputType) => {
        const responseData = await createCustomer(data)

        if (responseData && !responseData.error) {
            const id = encode(responseData.org._id);
            history.push(`/customer-management/profile/create/success/${id}`);
        } else {
            if (typeof responseData.error.message === "string") {
                toaster("error", responseData.error.message);
            } else {
                toaster("error", responseData.error.message.message.replace("\"", ""));
            }
        }
    }

    const handleFetchCompanyList = async () => {
        const responseData = await getCompanyList(org.logisticProviderOrgID);
        if (responseData && !responseData.error) {
            setOrgList(responseData);
        } else {
            if (typeof responseData.error.message === "string") {
                toaster("error", responseData.error.message);
            } else {
                toaster("error", responseData.error.message.message.replace("\"", ""));
            }
        }
    }

    return (
        <StackScreen
            title={
                <div>
                    <img
                        alt={t('alt.logo')}
                        src="/assets/images/banner_logo.png"
                        height={30}
                    />
                    <span className="ml-15">
                        {t("title.customerRegistration").toUpperCase()}
                    </span>
                </div>
            }
            isOpen={true}
            renderHeader={<div></div>}
            onClose={handleCloseStackScreen}
        >
            { componentTypeToLoad() }
        </StackScreen>
    );
}

export default CustomerCreatePage;